module.exports = __webpack_public_path__ + "img/emoji-30.d6fa655f.png";